<template>
  <c-table
    ref="table"
    title="위험형태별 원인 목록"
    :columns="grid.columns"
    :gridHeight="grid.height"
    :data="grid.data"
    :filtering="false"
    :columnSetting="false"
    :editable="editable"
  >
    <!-- 버튼 영역 -->
    <template slot="table-button">
      <q-btn-group outline >
        <c-btn v-if="editable&&visible" label="추가" icon="add" @btnClicked="add" />
        <c-btn v-if="editable&&visible" label="저장" icon="save" @btnClicked="save" />
      </q-btn-group>
    </template>
  </c-table>
</template>

<script>
export default {
  name: 'kpsr-cause',
  props: {
    param: {
      type: Object,
      default: () => ({
        disabled: false,
      }),
    },
    selectedRow: {
      type: Object,
      default: () => ({
        id: '',
        col1: '',
        useFlag: '',
        useFlagNm: '',
      }),
    },
  },
  data() {
    return {
      editable: true,
      grid: {
        columns: [
          {
            name: 'col1',
            field: 'col1',
            label: '원인(대분류)',
            align: 'center',
            style: 'width:90px',
            type: 'text',
            sortable: true,
          },
          {
            name: 'col2',
            field: 'col2',
            label: '원인(소분류)',
            align: 'left',
            style: 'width:200px',
            type: 'text',
            sortable: true,
          },
          {
            name: 'col4',
            field: 'col4',
            label: '공정구분',
            align: 'center',
            style: 'width:100px',
            type: 'multiSelect',
            itemText: 'codeName',
            itemValue: 'code',
            comboItems: [
              { code: '1', codeName: '연속식' },
              { code: '2', codeName: '회분식' },
            ],
            sortable: true,
          },
          {
            name: 'useFlag',
            field: 'useFlag',
            label: '사용여부',
            style: 'width:80px',
            align: 'center',
            sortable: true,
            type: 'check',
            true: 'Y',
            false: 'N',
          },
        ],
        data: [],
        height: '650px'
      },
      defaultData: [],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    visible() {
      return this.selectedRow && this.selectedRow.id
    }
  },
  watch: {
    selectedRow: {
      handler: function () {
        this.filterData();
      },
      deep: true,
    },
  },
  methods: {
    init() {
      // role setting
      // url setting
      // code setting
      // list setting
      this.getList();
    },
    getList() {
      this.defaultData = [
        { 
          id: '1', 
          cid: '1',
          col1: '부식', 
          col2: '내․외부 부식, 응력 부식, 크리프(Creep), 열적반복 등으로 인한 사항', 
          col3: '1,2', 
          col4: '1,2', 
          useFlag: 'Y',
        },
        { 
          id: '1', 
          cid: '2',
          col1: '침식', 
          col2: '마모 등으로 발생한 사항 모두 포함', 
          col3: '1,2', 
          col4: '1,2', 
          useFlag: 'Y',
        },
        { 
          id: '1', 
          cid: '3',
          col1: '누설', 
          col2: '플랜지, 밸브, 샘플링 포인트, 펌프 등에서 누유 및 누수 되는 사항 등', 
          col3: '1,2', 
          col4: '1,2', 
          useFlag: 'Y',
        },
        { 
          id: '1', 
          cid: '4',
          col1: '파열', 
          col2: '오염, 내부 폭굉, 물리적 과압, 팽창, 벤트 막힘, 제어실패, 과충전, 롤오버(Rollover), 수격현상, 순간증발(Flashing)', 
          col3: '1', 
          col4: '1', 
          useFlag: 'Y',
        },
        { 
          id: '1', 
          cid: '5',
          col1: '펑크', 
          col2: '기계적 에너지 발생, 충돌, 기계 진동, 과속 등', 
          col3: '1', 
          col4: '1', 
          useFlag: 'Y',
        },
        { 
          id: '1', 
          cid: '6',
          col1: '개방구 오조작', 
          col2: '벤트, 드레인, 압력방출 후단, 정비실수, 계기 정비, 샘플링 포인트, 블로우 다운, 호스, 탱크입하 및 출하 작업 실수', 
          col3: '1', 
          col4: '1', 
          useFlag: 'Y',
        },
        { 
          id: '1', 
          cid: '7',
          col1: '기타', 
          col2: '위 사항 외 기타 원인', 
          col3: '1,2', 
          col4: '1,2', 
          useFlag: 'Y',
        },
        { 
          id: '2', 
          cid: '21',
          col1: '물리적 과압', 
          col2: '입구․출구측 밸브 등의 폐쇄, 압력방출장치의 고장 등에 의한 과압', 
          col3: '1,2', 
          col4: '1,2', 
          useFlag: 'Y',
        },
        { 
          id: '2', 
          cid: '22',
          col1: '취급제한 화학물질 및 분진', 
          col2: '인화성 혼합물에 의한 화재, 폭주 반응, 촉매 이상에 의한 화재/폭발, 오염물질에 의한 조성 변화 등', 
          col3: '1,2', 
          col4: '1,2', 
          useFlag: 'Y',
        },
        { 
          id: '2', 
          cid: '23',
          col1: '점화원', 
          col2: '정전기, 스파크, 용접, 마찰열, 복사열, 차량 등에 의한 착화', 
          col3: '1,2', 
          col4: '1,2', 
          useFlag: 'Y',
        },
        { 
          id: '2', 
          cid: '24',
          col1: '누설', 
          col2: '플랜지, 밸브, 샘플링 포인트, 펌프 등에서 누유 및 누수 되는 사항 모두 포함', 
          col3: '1', 
          col4: '1', 
          useFlag: 'Y',
        },
        { 
          id: '2', 
          cid: '25',
          col1: '파열', 
          col2: '오염, 내부 폭굉, 물리적 과압, 팽창, 벤트 막힘, 제어실패, 과충전, 롤오버(Rollover), 수격현상, 순간증발(Flashing)', 
          col3: '1', 
          col4: '1', 
          useFlag: 'Y',
        },
        { 
          id: '2', 
          cid: '26',
          col1: '펑크', 
          col2: '기계적 에너지발생, 충격, 충돌, 기계 진동, 과속 등', 
          col3: '1', 
          col4: '1', 
          useFlag: 'Y',
        },
        { 
          id: '2', 
          cid: '27',
          col1: '개방구 오조작', 
          col2: '벤트, 드레인, 압력방출 후단, 정비실수, 계기 정비, 샘플링 포인트, 블로우 다운, 호스, 탱크입하 및 출하 작업 실수', 
          col3: '1', 
          col4: '1', 
          useFlag: 'Y',
        },
        { 
          id: '2', 
          cid: '28',
          col1: '기타', 
          col2: '위 사항 외 기타 원인', 
          col3: '1,2', 
          col4: '1,2', 
          useFlag: 'Y',
        },
        { 
          id: '3', 
          cid: '41',
          col1: '조업상 문제', 
          col2: '온도, 압력, 농도, pH, 교반, 조업 절차, 냉각실패 등 조업상 실수 등', 
          col3: '1,2', 
          col4: '1,2', 
          useFlag: 'Y',
        },
        { 
          id: '3', 
          cid: '42',
          col1: '원료 및 촉매 등 물질', 
          col2: '원료 및 촉매 등 이상에 의한 원인 등', 
          col3: '1,2', 
          col4: '1,2', 
          useFlag: 'Y',
        },
        { 
          id: '3', 
          cid: '43',
          col1: '기타', 
          col2: '위 사항 외 기타 원인', 
          col3: '1,2', 
          col4: '1,2', 
          useFlag: 'Y',
        },
        { 
          id: '4', 
          cid: '61',
          col1: '추락', 
          col2: '장치설비, 리프트, 플랫폼 등 구조물, 사다리, 계단 및 개구부 등에서의 추락 재료더미 및 적재물 등에서의 추락 등', 
          col3: '1,2', 
          col4: '1,2', 
          useFlag: 'Y',
        },
        { 
          id: '4', 
          cid: '62',
          col1: '전도', 
          col2: '누유 빙결 등에 의해 바닥에서의 미끄러짐, 바닥의 돌출물에 걸려 넘어짐, 장치설비, 계단에서의 전도 등', 
          col3: '1,2', 
          col4: '1,2', 
          useFlag: 'Y',
        },
        { 
          id: '4', 
          cid: '63',
          col1: '협착', 
          col2: '가동중인 설비, 기계장치에 협착 물체의 전도, 전복에 의한 협착, 교반기, 임펠러 등 회전체에 감김 등', 
          col3: '1,2', 
          col4: '1,2', 
          useFlag: 'Y',
        },
        { 
          id: '4', 
          cid: '64',
          col1: '충돌', 
          col2: '중량물, 파이프랙 등 돌출부에 접촉 및 충돌 구르는 물체, 흔들리는 물체에 접촉 및 충돌 차량 등과의 접촉 및 충돌 등', 
          col3: '1,2', 
          col4: '1,2', 
          useFlag: 'Y',
        },
        { 
          id: '4', 
          cid: '65',
          col1: '유해 위험 물질 접촉', 
          col2: '뜨거운 물체에 접촉하여 화상, 부식성 물질 등에 접촉하여 피부손상 등', 
          col3: '1,2', 
          col4: '1,2', 
          useFlag: 'Y',
        },
        { 
          id: '4', 
          cid: '66',
          col1: '질식', 
          col2: '유해가스 발생, 산소 부족 등에 의한 질식', 
          col3: '1,2', 
          col4: '1,2', 
          useFlag: 'Y',
        },
        { 
          id: '4', 
          cid: '67',
          col1: '기타', 
          col2: '전류 접촉에 의한 감전사고, 낙하, 비래, 비산, 붕괴, 도괴 사고, 중량물 취급 및 원재료 투입 시 요통 발생 압박, 진동 등 위 사항 외 기타 원인', 
          col3: '1,2', 
          col4: '1,2', 
          useFlag: 'Y',
        },
      ];
      this.filterData();
    },
    filterData() {
      if (this.selectedRow.id) {
        this.grid.data = this.$_.filter(this.defaultData, { id: this.selectedRow.id })
      } else {
        this.grid.data = [];
      }
    },
    add() {
      let date = new Date();
      this.grid.data.splice(0, 0, {
        id: this.selectedRow.id, 
        cid: String(date.getTime()),
        col1: '', 
        col2: '', 
        col3: '', 
        col4: '', 
        useFlag: 'Y',
      })
    },
    save() {
      let checkItem = ['col1', 'col2', 'col4']
      let isConti = true;
      this.$_.forEach(this.grid.data, item => {
        this.$_.forEach(checkItem, check => {
          if (!item[check]) {
            isConti = false;
            return false;
          }
        })
      });

      if (!isConti) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '필수 입력값을 입력해 주세요. [원인(대분류), 원인(소분류), 공정구분]',
          type: 'warning', // success / info / warning / error
        });
      }
    },
  }
};
</script>
